import React from 'react';
import '../App.css';
import WelComeLayer from '../components/WelcomeLayer'
import 'bootstrap/dist/css/bootstrap.min.css';
import SsoSignInForm from "../components/SSOSignInForm";
import {IMAGES} from "../util/Messages";

class SSOLoginApp extends React.Component {
  render() {
    return (
      <>
        <WelComeLayer logo={IMAGES.colsubidio} />
        <SsoSignInForm/>
      </>
    );
  }
}

export default SSOLoginApp;
